import styled from 'styled-components';
import { font, mixin } from 'utils/styles';

export const Image = styled.div.attrs((props) => ({
  size: props.size,
  avatarUrl: props.avatarUrl,
}))`
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 100%;
  ${(props) => mixin.backgroundImage(props.avatarUrl)}
`;

export const Letter = styled.div.attrs((props) => ({
  size: props.size,
}))`
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 100%;
  text-transform: uppercase;
  color: #fff;
  background: ${(props) => props.color};
  ${font.medium}
  ${(props) => font.size(Math.round(props.size / 1.7))}
  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;
